module.exports = __webpack_public_path__ + "img/back_address4.3cfaf58b.png";